<template>
    <div class="all">
        <div class="warp">
            <div class="warp-header">
                <h2>在线反馈</h2>
            </div>
            <div class="warp-body clearfix">
                <!-- 建方案 -->
                <div class="form-warp input-list field fl">
                    <div class="item clearfix">
                        <span class="name fl">反馈类型:</span>
                        <div class="input-father">
                            <div class="corm clearfix">
                                <span class="element" :class="type === 2 ? 'curr' : ''" @click="selectType(2);">改进建议</span>
                                <span class="element" :class="type === 1 ? 'curr' : ''" @click="selectType(1);">功能缺陷</span> 
                                <span class="element" :class="type === 3 ? 'curr' : ''" @click="selectType(3);">商务合作</span>
                            </div>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">上传图片:</span>
                        <div class="input-father">
                            <div class="file-warp">
                                <input class="file" type="file" value="上传文件" @change="updateImg($event);" accept="image/gif,image/jpeg,image/jpg,image/png"/>
                                <button class="btn save btn-jbblue"><i class="icons add-icon"></i>点击上传</button>
                            </div>
                            <img :src="previewImg" v-if="previewImg != ''" class="preview-img mt10 db"/>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl"><i class="color-red">*</i> 反馈模块:</span>
                        <span class="drop-down">
                            <button class="btn btn-lightblue"><span class="text">{{feedName !='' ? feedName : '选择反馈模块'}}</span><i class="icons"></i></button> 
                            <ul class="option" style="min-width:130px;">
                                <li v-for="(item,index) in feedbackMoudle" @click="selectFeedMoudle(item);" :key="index">{{item}}</li> 
                            </ul>
                        </span>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl"><i class="color-red">*</i> 反馈内容:</span>
                        <div class="input-father">
                            <textarea class="area" v-model.trim="textarea" name="" rows="4" cols="" maxlength="200" placeholder="反馈内容最多200字"></textarea>
                        </div>
                    </div>
                    <div class="form-btn">
                        <button class="btn save btn-jbblue" type="submit" @click="saveFeedback();">提交反馈</button>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
export default {
    components:{Dialog},
    data() {
        return {
            type:2,
            imgFile:'',
            previewImg:'',//预览图
            textarea:'',//反馈类容
            //反馈模块
            feedbackMoudle:['创建/修改方案','舆情总览','信息汇总','传播分析','自动预警','报告中心','竞对报告','事件传播分析','全文检索'],
            feedName:''
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
           
        }) 
    },
    created() {
		
    },
    methods: {
        selectFeedMoudle (name) {
            this.feedName = name;
        },
        // 选择类型
        selectType (type) {
            this.type = type;
        },
        // 图片上传
        updateImg (event) {
            let file = event.target.files;
            let files = file[0];
            this.imgFile = files;
            this.previewImg = window.URL.createObjectURL(files); 
        },
        // 提交反馈
        saveFeedback () {
            let that = this;
            if(that.imgFile.size/1024/1024 > 2){
                that.$utils.alertText('图片限制最大2M');
                return;
            }else if(that.textarea == ''){
                that.$utils.alertText('反馈内容不能为空');
                return;
            }else if(that.feedName == ''){
                that.$utils.alertText('请选择反馈模块');
                return;
            }
            let formData = new FormData();
            formData.append('data[feedType]', that.type);
            formData.append('data[context]', that.textarea);
            formData.append('feedImg', that.imgFile);
            formData.append('data[feedbackModule]', that.feedName);
            
            that.$api.post('user/feedback/create', formData, r => {
                that.$parent.returnCode(r,function(){
                    that.type = 2;
                    that.imgFile = '';
                    that.previewImg = '';
                    that.textarea = '';
                    that.feedName = '';
                    that.$utils.alertText('提交成功，感谢您的反馈');
                })
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/feedback.vue